import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Heading, Wrapper, SubHeading, Paragraph, Head } from '@/shared/styled'
import DockerIcon from '@/components/svg/syllabus/DockerIcon'
import GoIcon from '@/components/svg/syllabus/GoIcon'
import GitIcon from '@/components/svg/syllabus/GitIcon'
import SwiftIcon from '@/components/svg/syllabus/SwiftIcon'
import CLIIcon from '@/components/svg/syllabus/CLIIcon'
import BlockchainIcon from '@/components/svg/syllabus/BlockchainIcon'
import FindFriendIcon from '@/components/svg/syllabus/FindFriendIcon'
import FortressIcon from '@/components/svg/syllabus/FortressIcon'

const techChoices = [
  {
    Icon: DockerIcon,
    content:
      'Apply basic DevOps: Containerized, Docker, Continuous Integration, Continuous Delivery',
  },
  {
    Icon: SwiftIcon,
    content:
      'We have Swift for Apple fans to build your iOS applications, and for those who choose to go with Android, we got you covered with Kotlin.',
  },
  {
    Icon: GoIcon,
    content:
      'Speaking multiple languages at once: You will be taught to use Golang as the primary backend language; Agile and Scrum process to manage your work.',
  },
  {
    Icon: CLIIcon,
    content: 'Be a Vim user or master another editor. Become a CLI user',
  },
  {
    Icon: GitIcon,
    content: 'Use GIT for tracking file changes and version control system',
  },
  {
    Icon: BlockchainIcon,
    content: 'Get your hands on Blockchain and AI',
  },
]

const TechBlock = styled.div`
  ${tw`px-5 lg:w-1/2 w-full mb-10 flex items-start`};
  ${props => (props.alignRight ? tw`justify-end` : '')}
`

const TechBlockWrapper = styled.div`
  width: 460px;
  ${tw`flex items-center`};
`

const IconWrapper = styled.div`
  flex: 67px 0 0;
  ${tw`mr-8`};
`

const InvolvedBlock = styled.div`
  background-color: ${props => props.theme.greyLighter};
  border-radius: 20px;
  ${tw`px-8 py-8`};
  ${props => (props.center ? tw`flex items-center w-full justify-center` : '')};
`

const AppIconWrapper = styled.div`
  flex: 77px 0 0;
`

const AppBlock = ({ Icon, name, desc }) => (
  <div className="flex">
    <AppIconWrapper>
      <Icon />
    </AppIconWrapper>
    <div className="ml-8">
      <h5 className="text-xl font-semibold mb-3">{name}</h5>
      <Paragraph>{desc}</Paragraph>
    </div>
  </div>
)

const RecapBlock = styled.div`
  max-width: 640px;
  margin: auto;
  box-shadow: 0 2px 10px #dcdcdd;
  border-radius: 20px;
  ${tw`sm:p-9 py-9 px-5 flex`};
`

const Quote = styled.span`
  font-size: 72px;
  line-height: 1em;
  display: block;
  font-weight: 500;
  color: ${props => props.theme.primary};
  ${props =>
    props.alignBottom ? tw`flex items-end ml-5` : tw`flex items-start mr-5`};
  line-height: ${props => (props.alignBottom ? '0' : '1em')};
`

const SyllabusSection = () => {
  return (
    <section className="sm:py-24 py-12" id="syllabus">
      <Wrapper>
        <Head>
          <Heading>Our Syllabus</Heading>
          <Paragraph>
            To make sure your time with us is well-spent, we offer you real
            projects with our adepts and the chance to work with global
            customers.
          </Paragraph>
          <SubHeading className="mt-24">
            Bring your best curiosity and initial to make your way in these open
            doors:
          </SubHeading>
        </Head>

        <div className="-mx-5 flex flex-wrap mt-20">
          {techChoices.map(({ Icon, content }, index) => (
            <TechBlock alignRight={index % 2 !== 0} key={index}>
              <TechBlockWrapper>
                <IconWrapper>
                  <Icon />
                </IconWrapper>
                <Paragraph>{content}</Paragraph>
              </TechBlockWrapper>
            </TechBlock>
          ))}
        </div>

        <Head className="mb-20">
          <SubHeading className="sm:mt-24 mt-16">
            And for your practical training:
          </SubHeading>
        </Head>

        <div className="-mx-5 flex flex-wrap mb-10">
          <div className="px-5 lg:w-1/3 sm:w-1/2 w-full mb-10">
            <InvolvedBlock>
              <AppBlock
                Icon={FindFriendIcon}
                name={'Find Friends'}
                desc={
                  'Find Friends is an app that enables users to share their locations with their teammates'
                }
              />
            </InvolvedBlock>
          </div>
          <div className="px-5 lg:w-1/3 sm:w-1/2 w-full mb-10">
            <InvolvedBlock>
              <AppBlock
                Icon={FortressIcon}
                name={'Fortress'}
                desc={
                  'Fortress is a web app for company operation management based on DotA game features'
                }
              />
            </InvolvedBlock>
          </div>
          <div className="px-5 lg:w-1/3 w-full flex mb-10">
            <InvolvedBlock center>
              <p className="text-xl opacity-75 text-center">
                <span>And other projects for </span>
                <b className="font-medium">AI</b> <span>and</span>{' '}
                <b className="font-medium">Blockchain</b>!
              </p>
            </InvolvedBlock>
          </div>
        </div>

        <Head className="sm:mb-20 mb-18 mt-20">
          <SubHeading>Reap your Rewards</SubHeading>
        </Head>
        <RecapBlock>
          <Quote>“</Quote>
          <Paragraph>
            There's no shortcut to help you grow than get your hands on the job.
            Coffee runs helps nothing but binds you with grudging obedience.
            More than the proficiencies to build microservices, web and mobile
            application, we hope it encourages you to live by the philosophy of
            technophiles, and the enthusiasm of surpass your limit and the urge
            to create world-class products by cutting edge technologies.
          </Paragraph>
          <Quote alignBottom>“</Quote>
        </RecapBlock>
      </Wrapper>
    </section>
  )
}

export default SyllabusSection
